import React from 'react';
import { render } from 'react-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { connect } from 'react-redux';
import { install } from 'redux-loop';
import { Container } from './components/Container';
import reducer, { Actions } from './reducer';
import awaitLegacyJquery from './lib/awaitLegacyJquery';
import awaitAsynchronousCards from './lib/awaitAsynchronousCards';
import Copy from './copy';
import memoizedConnector from './lib/memoizedConnector';

const handleRemoveItem = (onRemove) => () => (next) => (action) => {
  if (action.type === Actions.removeLineItemSuccess.getType()) {
    onRemove(action.payload);
  }
  next(action);
};

const handleLoadItems = (onLoad) => () => (next) => (action) => {
  if (action.type === Actions.loadLineItemsSuccess.getType()) {
    onLoad(action.payload);
  }
  next(action);
};

const handleGetSessionInfo = (func) => () => (next) => (action) => {
  if (action.type === Actions.getSessionInfoSuccess.getType()) {
    func(action.payload);
  }
  next(action);
};

export default {
  init: () => {
    awaitLegacyJquery().then($ => awaitAsynchronousCards($)).then(($) => {
      const listingsDeduplicated = !(typeof(window.Raise.data.optimizely) === 'undefined')
        && window.Raise.data.optimizely
        && window.Raise.data.optimizely.deduplicate;
      const updateTotalCards = ($row, $group, newTotal, added) => {
        if($row.data('inCart') !== added) {
          $row.attr('data-in-cart', added);
          $row.data('inCart', added);
          $group.find('.card').data('totalCards', newTotal);
          $group.find('.card').attr('data-total-cards', newTotal);
          $group.find('.card').removeClass('card-show');
          $group.find('.cards-available-number').text(newTotal);
          const $showCard = ($group.find('.card[data-in-cart="false"]').length)
            ? $group.find('.card[data-in-cart="false"]').eq(0)
            : $group.find('.card').eq(0);
          $showCard.addClass('card-show');
        }
      };

      const disableRowInjected = (buttonCopy, $row) => {
        const $button = $row.find('.add-to-cart');
        $button
            .attr('disabled', true)
            .removeClass('btn-primary')
            .data('originalCopy', $button.text())
            .val(buttonCopy);
        updateTotalCards($row, $row.parent(), $row.data('totalCards') - 1, true);
      };

      const disableRowRendered = (buttonCopy, $row) => {
        $row.addClass('already-added');
        const $button = $row.find('.add-to-cart');
        $button
          .attr('disabled', true)
          .removeClass('btn-primary')
          .data('originalCopy', $button.text())
          .val(buttonCopy);
      };

      const disableRow = (buttonCopy) => ({ productId }) => {
        const $row = $(`#${productId}`);
        if (listingsDeduplicated) {
          disableRowInjected(buttonCopy, $row);
        } else {
          disableRowRendered(buttonCopy, $row);
        }
      };

      const disableInCart = disableRow(Copy.inCartButton);
      const disableUnavailable = disableRow(Copy.unavailableButton);

      const enableRowInjected = ($row) => {
        const $button = $row.find('.add-to-cart');
        $button
          .addClass('btn-primary')
          .attr('disabled', false)
          .val($button.data('originalCopy') || 'Buy Now');
        updateTotalCards($row, $row.parent(), $row.data('totalCards') + 1, false);
      };

      const enableRowRendered = ($row) => {
        $row.removeClass('already-added');
        const $button = $row.find('.add-to-cart');
        $button
          .addClass('btn-primary')
          .attr('disabled', false)
          .val($button.data('originalCopy') || 'Buy Now');
      };

      const enableRow = ({ productId }) => {
        const $row = $(`#${productId}`);
        if (listingsDeduplicated) {
          enableRowInjected($row);
        } else {
          enableRowRendered($row);
        }
      };

      $(() => {
        const el = document.querySelector('li.cart');

        if (!el) {
          return;
        }

        const store = createStore(
          reducer,
          undefined,
          compose(
            install(),
            applyMiddleware(
              handleRemoveItem(enableRow),
              handleLoadItems((response) => response.lineItems.forEach(disableInCart)),
              handleGetSessionInfo((response) => response),
            ),
            window.devToolsExtension ? window.devToolsExtension() : (x) => x
          )
        );

        $(document).on('ajax:complete', 'form[action="/orders/populate"]', (ev, jqXhr) => {
          setTimeout(() => {
            jqXhr.promise().then(
              () => {
                store.dispatch(Actions.open());
                store.dispatch(Actions.loadLineItemsStart());
              },
              () => {
                const variants = jqXhr.responseJSON && jqXhr.responseJSON.variants;
                const brandName = jqXhr.responseJSON && jqXhr.responseJSON.brandName;

                if (variants && variants.length) {
                  disableUnavailable({
                    productId: variants[0],
                  });
                }

                store.dispatch(Actions.open());
                store.dispatch(Actions.addLineItemFailure(brandName || ''));
              }
             );
          }, 600);
        });

        function extSetState(state) {
          store.dispatch(Actions.setCartContextState(state));
        }

        const Master = props => {
          return (
            <Container {...props} extSetState={extSetState}/>
          );
        };

        const Slave = props => {
          return (
            <Container {...props} isSlave extSetState={extSetState}/>
          );
        };

        const connector = memoizedConnector((s) => ({ model: s.toJS() }));
        const ConnectedContainer = connect(connector)(Master);
        const MobileWebConnectedContainer = connect(connector)(Slave);

        store.dispatch(Actions.getSessionInfoStart());

        render(<ConnectedContainer store={store} />, el);

        const mel = document.querySelector('.mobile-cart');

        if (!mel) {
          return;
        }

        render(<MobileWebConnectedContainer store={store} />, mel);
      });
    });
  },
};
